import React from 'react';
import { About } from '../components/About';
export function AboutPage() {
  return <main data-id="element-2184">
      <About data-id="element-2185" />
    </main>;
}